export function generateDate(date: string) {
  const dateString = date.replace(/ /g, "T");
  return new Date(Date.parse(dateString));
}

export function getDateAsDayMonthYear(dateAsString: string) {
  const date = new Date(dateAsString);
  return date.getDate() + '-' + (date.getMonth() + 1) + '-' + date.getFullYear();
}
